<template>
    <div>
        <PageTitle :title="title"></PageTitle>
        <div class="ct_wrapper">
            <dl v-if="lang === 'ru'">
                <dt>Дата рождения:</dt>
                <dd>18 мая 1977г.</dd>
                <dt>Страна:</dt>
                <dd>Россия</dd>
                <dt>Город:</dt>
                <dd>Новосибирск</dd>
                <dt>Образование:</dt>
                <dd>высшее</dd>
                <dt>Основное:</dt>
                <dd><a href="http://www.nspu.net/" target="_blank">ГОУ ВПО НГПУ</a>,
                    <a href="http://math.nspu.ru/" target="_blank">Математический факультет</a>, 1993-1998 г.г.
                </dd>
                <dd>Аспирантура 13.00.02 1998-2001 г.г.</dd>
            </dl>
            <dl v-else>
                <dt>Date of birth:</dt> <dd>18 may 1977г.</dd>
                <dt>Country:</dt> <dd>Russia</dd>
                <dt>City:</dt> <dd>Novosibirsk</dd>
                <dt>Education:</dt> <dd>Higher</dd>
                <dt>Main: </dt><dd><a href="http://www.nspu.net/" target="_blank">NSPU</a> ,
                <a href="http://math.nspu.ru/" target="_blank">Mathematical faculty</a>, 1993-1998 г.г.</dd>
                <dd>Postgraduate study 13.00.02 1998-2001 г.г.</dd>
            </dl>
        </div>
    </div>
</template>
<script>
import PageTitle from '@/components/PageTitle.vue'

export default {
  name: 'About',
  data() {
    return {
    }
  },
  props: {
    lang: String,
    title: String
  },
  components: {
    PageTitle
  }
}
</script>
